<template>
  <div class="container_cm">
    <div class="main_cm">
      <div class="bh_cm">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/guidance' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资料管理</el-breadcrumb-item>
          <el-breadcrumb-item>批量取出</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="top_cm">
        <div>
          <span>仓库</span>
          <el-select v-model="searchForm.depotId" clearable placeholder="请选择仓库">
            <el-option v-for="item in depotLst" :key="item.id" :label="item.depotName" :value="item.id">
            </el-option>
          </el-select>
          <span>出库原因</span>
          <el-select v-model="searchForm.fetchType" clearable placeholder="请选择原因">
            <el-option v-for="item in fetchTypes" :key="item.fetchTypeId" :label="item.fetchTypeName"
              :value="item.fetchTypeId">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-button class="mybtny" v-waves icon="el-icon-search" @click="toSearch">搜索</el-button>
          <el-button class="mybtny" v-waves icon="el-icon-edit" @click="addProject">新增</el-button>
        </div>
      </div>
      <div class="table_cm">
        <Table  v-loading="loading" :tableData="List" :pageSize='pageSize' :currentPage="pageIndex"
          :cloumns="cloumns" :totalNum="total" :pageFlag='true' :selection='false'
          @handleCurrentChange="handleCurrentChange">
          <el-table-column prop="fetchTypeName" label="出库原因" align="center">
          </el-table-column>
          <el-table-column prop="depotName" label="所属仓库" align="center" sortable>
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人" align="center" sortable>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" sortable>
          </el-table-column>
          <el-table-column prop="statesName" label="状态" align="center" sortable>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <!-- <el-button type="text" v-if="scope.row.states==0" @click.native.prevent="editClick(scope.row)">编辑</el-button> -->
              <el-button type="text" v-if="scope.row.states == 0" @click.native.prevent="stop(scope.row)">删除</el-button>
              <el-button type="text" @click.native.prevent="versionmana(scope.row)">查看明细</el-button>
            </template>
          </el-table-column>
        </Table>
      </div>
    </div>
    <!-- 新增 -->
    <div>
      <el-dialog title="新增出库单" center :visible.sync="addVisible" width="1080px" v-if="addVisible"
        :close-on-click-modal="false">
        <el-form :model="detailCondition" :inline="true" ref="detailCondition">
          <el-form-item label="仓库：">
            <el-select size="medium" v-model="detailCondition.depotId" @change="changeDepot" clearable placeholder="请选择仓库">
              <el-option v-for="item in depotLst" :key="item.id" :label="item.depotName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出库原因：">
            <el-select size="medium" v-model="detailCondition.fetchType" clearable placeholder="请选择原因">
              <el-option v-for="item in fetchTypes" :key="item.fetchTypeId" :label="item.fetchTypeName"
                :value="item.fetchTypeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仪器名称：">
            <el-input  size="medium" v-model="detailCondition.searchInfo" placeholder="请输入"></el-input>
          </el-form-item>
          <el-button type="primary" size="medium" @click="inquire" icon="el-icon-search">查询</el-button>
        </el-form>
        <el-table :row-key="getRowKeys"  border ref="multipleTable" @selection-change="handleSelectionChange" :data="record" height="400" v-loading="detailLoading"
          style="width: 100%">
          <el-table-column type="selection" width="55" :reserve-selection="true" />
          <el-table-column type="index" label="序号" align="center" width="50" />
          <el-table-column prop="instrumentName" label="仪器名称" align="center" />
          <el-table-column prop="serialNumber" label="仪器编号" align="center" />

        </el-table>
        <div class="resource-block">
          <el-pagination @size-change="detailHandleSizeChange" @current-change="detailHandleCurrentChange"
            :current-page="detailCondition.current" :page-sizes="[10, 20, 50, 100]" :page-size="detailCondition.size"
            layout="total, sizes, prev, pager, next, jumper" :total="detailTotal">
          </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="addVisible = false">取 消</el-button>
    <el-button type="primary" @click="submit('add')">确 定</el-button>
  </span>
      </el-dialog>
    </div>
    <!-- 查看明细 -->
    <div>
      <el-dialog title="出库单明细" center :visible.sync="versionListVisible" width="700px" v-if="versionListVisible">
        <showFetch :fetchRecord="fetchRecord" @cancel="cancelVersionList"></showFetch>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getFetchPageLst, createFetch, deleteFetch } from "@/api/fetchApi.js";
import { getDepotInfo } from "@/api/depotApi";
import addFetch from "./components/addFetch";
import showFetch from "./components/showFetch";
import Table from "@/components/myTable";
import { getFreeLst } from "@/api/fetchApi";
export default {
  inject: ["reload"],
  components: {
    addFetch,
    Table,
    showFetch,
  },
  data() {
    return {
      getRowKeys(row){
        return row.id
      },
      fetchTypes: [
        { fetchTypeId: 1, fetchTypeName: "借出" },
        { fetchTypeId: 2, fetchTypeName: "检定" },
        { fetchTypeId: 3, fetchTypeName: "维修" },
        { fetchTypeId: 4, fetchTypeName: "保养" },
        { fetchTypeId: 5, fetchTypeName: "其他" },
      ],
      userInfo: "",
      List: [],
      cloumns: [],
      loading: false,
      detailLoading: false,
      pageIndex: 1, //默认当前页
      pageSize: 10, //每页显示数量
      total: 0, //总条数
      searchForm: {},
      addVisible: false, //新增项目弹窗
      editVisible: false, //编辑项目弹窗
      editData: "", //待编辑项目数据
      versionListVisible: false,
      versionList: {},
      depotLst: [],
      fetchTypes: [],
      fetchRecord: {},
      record: [],
      detailTotal: 0,
      multipleSelection: [],
      detailCondition: {
        searchInfo: null,
        depotId: "",
        fetchType: "",
        current: 1,
        size: 10,
      }
    };
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
    this.depostInfo();
    this.fetchTypes = [
      { fetchTypeId: 1, fetchTypeName: "借出" },
      { fetchTypeId: 2, fetchTypeName: "检定" },
      { fetchTypeId: 3, fetchTypeName: "维修" },
      { fetchTypeId: 4, fetchTypeName: "保养" },
      { fetchTypeId: 5, fetchTypeName: "其他" },
    ];
  },
  mounted() {
    this.getStandardList();
  },
  methods: {
    inquire() {
      this.detailCondition.current = 1;
      this.getDetailList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map(it => it.id);
    },
    detailHandleSizeChange(page) {
      this.detailCondition.size = page;
      this.getDetailList()
    },
    detailHandleCurrentChange(page) {
      this.detailCondition.current = page;
      this.getDetailList();
    },
    changeDepot() {
      this.multipleSelection = []
      this.$refs.multipleTable.clearSelection();
      this.detailCondition.current = 1;
      this.detailCondition.size = 10;
      this.getDetailList();
    },
    getDetailList() {
      let self = this;
      self.detailLoading = true;
      let params = {
        ...this.detailCondition
      }
      getFreeLst(params).then((res) => {
        self.detailLoading = false;
        if (res.code != 200) {
          return;
        }
        self.record = res.data.records;
        self.detailTotal = res.data.total;
      }).finally(() => self.detailLoading = false);
    },
    //获取仓库数据
    depostInfo() {
      let self = this;
      getDepotInfo({ deptId: this.userInfo.deptId }).then((res) => {
        if (res.code == "200") {
          self.depotLst = res.data;
        }
      });
    },
    getStandardList() {
      let params = {
        current: this.pageIndex,
        size: this.pageSize,
        ...this.searchForm,
      };
      this.loading = true;
      getFetchPageLst(params)
        .then((res) => {
          if (res.code == "200") {
            this.List = res.data.records;
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg || "服务器连接失败");
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.msg || err.message || "服务器连接失败");
        });
    },
    toSearch() {
      this.pageIndex = 1;
      this.getStandardList();
    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getStandardList();
    },
    // 刷新
    refresh() {
      this.reload();
    },
    // 新增项目
    addProject() {
      this.multipleSelection = []
      this.detailCondition = {}
      this.addVisible = true;
      this.inquire()
    },
    // 编辑项目
    editClick(row) {
      let { standardCode, standardName, version, fileName, filePath, id } = row;
      this.editData = {
        standardCode,
        standardName,
        version,
        fileName,
        filePath,
        id,
      };
      this.editVisible = true;
    },
    // 新增/编辑项目提交
    submit(type) {
      if (!this.detailCondition.depotId) {
        this.$message({
          message: "请选择仓库",
          type: "warning",
        });
        return;
      }
      if (!this.detailCondition.fetchType) {
        this.$message({
          message: "请选择出库原因",
          type: "warning",
        });
        return;
      }
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择仪器",
          type: "warning",
        });
        return;
      }
      if (type=='add') {
        let params ={
          insId:this.multipleSelection,
          depotId:this.detailCondition.depotId,
          fetchType: this.detailCondition.fetchType,
        }
        createFetch(params).then((res) => {
          if (res.code == "200") {
            this.$message.success(res.msg || "新增成功！");
            this.cancel();
            this.getStandardList();
          } else {
            this.$message.error(res.msg || "新增失败！");
          }
        });
      } else {
        updateCompany({ ...data }).then((res) => {
          if (res.code == "200") {
            this.$message.success(res.msg || "修改成功！");
            this.cancelEdit();
            this.getStandardList();
          } else {
            this.$message.error(res.msg || "修改失败！");
          }
        });
      }
    },
    // 新增取消
    cancel() {
      this.addVisible = false;
    },
    // 编辑取消
    cancelEdit() {
      this.editVisible = false;
    },
    // 停用
    stop(row) {
      this.$confirm("确定删除吗?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteFetch(row.id).then((res) => {
            if (res.code == "200") {
              this.$message.success(res.msg || "删除成功！");
              this.getStandardList();
            } else {
              this.$message.error(res.msg || "删除失败！");
              this.getStandardList();
            }
          });
        })
        .catch(() => { });
    },
    versionmana(row) {
      this.fetchRecord = row;
      this.versionListVisible = true;
    },
    cancelVersionList() {
      this.versionListVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.container_cm {
  width: 100%;
  height: calc(100% - 30px);
  padding: 15px 0;

  .main_cm {
    height: calc(100% - 82px);
    margin: 0 auto;

    .bh_cm {
      height: 20px;
      line-height: 20px;
    }

    .top_cm {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;

      .el-input {
        width: 200px;
        margin: 0 20px;
      }

      .el-button {
        width: 140px;
        margin-left: 20px;
      }

      .el-select {
        margin: 0 20px;
      }
    }

    .table_cm {
      height: 100%;
    }
  }
}
.resource-block {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/fetch/index.vue